import { AutocompleteRenderInputParams } from "@remo-co/ui-core/src/components/Autocomplete";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Input } from "@remo-co/ui-core/src/components/Input";
import { Tooltip } from "@remo-co/ui-core/src/components/Tooltip";
import { LinkIcon } from "@remo-co/ui-core/src/icons/Link";
import { useI18n } from "i18n";
import { Lock as LockIcon } from "@remo-co/ui-core/src/icons/Lock";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useStyles } from "./styles";

interface Props {
  params: AutocompleteRenderInputParams;
  error: boolean;
  directories: string[];
  isPrivateEvent?: boolean;
  isMultipleEventDirectories?: boolean;
}

export const LinkedLockedEventsInput = ({
  params,
  error,
  directories,
  isPrivateEvent,
  isMultipleEventDirectories,
}: Props) => {
  const styles = useStyles({ isPrivateEvent, isMultipleEventDirectories });
  const { t } = useI18n(["eventDirectory"]);

  return (
    <Tooltip
      arrow
      title={
        <div>
          {isMultipleEventDirectories && !isPrivateEvent && (
            <>
              <Typography>
                {t("eventDirectory:event.linked.in.other.directories")}
                {directories.join(", ")}.
              </Typography>
              <Typography>
                {t("eventDirectory:guests.in.linked.events.description")}
              </Typography>
            </>
          )}
          {isPrivateEvent && (
            <Typography>
              {t("eventDirectory:private.event.description")}
            </Typography>
          )}
        </div>
      }
      placement="right"
      PopperProps={{
        disablePortal: true,
      }}
      classes={{
        tooltip: styles.toolTip,
        arrow: styles.toolTipArrow,
      }}
    >
      <Container ref={params.InputProps.ref} className={styles.inputContainer}>
        <Input
          {...params.inputProps}
          inputProps={{
            "data-testid": "multiple-event-list-input",
          }}
          size="sm"
          placeholder={t("eventDirectory:search.or.choose.event")}
          fullWidth
          inputEndAdornment={
            <div className={styles.inputAdornment}>
              {isMultipleEventDirectories && (
                <LinkIcon className={styles.linkIcon} />
              )}
              {isPrivateEvent && (
                <div className={styles.lockIcon}>
                  <LockIcon />
                </div>
              )}
              {params.InputProps.endAdornment}
            </div>
          }
          error={error}
        />
      </Container>
    </Tooltip>
  );
};
